module.exports = __webpack_public_path__ + "img/gift7.a54cf6af.png";